export default {"src":"/_next/static/media/money.58df1236.svg","height":100,"width":150};